import type { RouteObject } from 'react-router';

import { ROUTES } from '@/constants/routes';

/** Every staff account has the dashboard; each block on it checks its own permission. */
export const dashboardRoutes: RouteObject[] = [
  {
    path: ROUTES.DASHBOARD,
    lazy: async () => ({ Component: (await import('./pages/DashboardPage')).DashboardPage }),
  },
];
